import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { SearchActions } from 'src/app/common/store/actions/search.actions';
import { selectAllSearchedCarsPreviewTotalCount, selectMakes, selectModels, selectSearchCriteria, selectSearchFetchingPreview, selectVersions } from 'src/app/common/store/state/app.state';
import { Observable } from 'rxjs';
import { selectSearchFetchingResults } from 'src/app/common/store/reducers/search.reducer';

import { DealerActions } from 'src/app/common/store/actions/dealer.actions';

import { DateRange, MatDatepickerModule, MatDateRangeInput } from '@angular/material/datepicker';

import { CarRefActions } from 'src/app/common/store/actions/carref.actions';
import { AppConstants } from 'src/app/public/common/constants/app-constants';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBusinessLine, CarBasicData } from 'src/app/public/car/constants/car-basic-data';
import { GeneralBasicData } from 'src/app/public/common/constants/general-basic-data';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSliderModule } from '@angular/material/slider';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AsyncPipe } from '@angular/common';
import { Country } from 'src/app/public/common/models/country.model';
import { CarCriteria } from '../../models/car-criteria.model';
import { CarMake } from '../../models/car-make.model';
import { CarModel } from '../../models/car-model.model';
import { CarVersion } from '../../models/car-version.model';


@Component({
    selector: 'app-car-search-criteria',
    templateUrl: './car-search-criteria.component.html',
    styleUrls: ['./car-search-criteria.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatDatepickerModule, MatSliderModule, MatSelectModule, MatIconModule, MatProgressSpinnerModule, AsyncPipe, MatDateRangeInput]
})
export class CarSearchCriteriaComponent implements OnInit{

  disabled = false;

  //businessLinesBD : string [] = [CarBusinessLine.SALE, CarBusinessLine.RENTAL];
  
  //selectedBusinessLine: string = CarBusinessLine.SALE;
  @Input() selectedBusinessLine?: CarBusinessLine;
  
  pMin = 0; 
  pMax = 0; 
  step = 1; 
  
  yMin = AppConstants.CAR_YEAR_MIN;
  yMax = new Date().getFullYear();

  showTicks = false;
  
  thumbLabel = true;
  value = 0;

  gearboxesBD = CarBasicData.gearboxes;
  fuelTypesBD = CarBasicData.fuelTypes;
  
  carMakesBD: string [] = [];
  carModelsBD: string [] = [];

  makes$: Observable<CarMake[]>;
  models$: Observable<CarModel[]>;
  versions$: Observable<CarVersion[]>;

  selectedMakes: CarMake[] = [];
  selectedModels: CarModel[] = [];
  selectedVersions: CarVersion[] = [];

  countriesBD: Country [] = [];
  citiesBD: string [] = [];

  todayDate: Date;
  tomorrowDate: Date;
  yesterdayDate: Date;
  selectedDateRange: DateRange<Date>;

  //showCriteriaPanel: boolean = true;
  showCriteriaPanel: boolean = (window.innerWidth > AppConstants.SCREEN_BREAK_L);

  carCriteria: CarCriteria = new CarCriteria();

  fetchingPreview$: Observable<boolean>;
  previewTotalCount$: Observable<number>;

  searchCriteria$: Observable<CarCriteria>;
  

  //selectedCountryCodes$: Observable<string[]>;
  //selectedCountryCodes: string[] = [];
  selectedCountryCodes: string[] = [];
  countryCodeOptions: string[] = AppConstants.COUNTRY_CODE_OPTIONS;

  CarBusinessLine = CarBusinessLine;

  constructor(
    private store: Store,
    private router: Router, 
    private route: ActivatedRoute) {

      this.makes$ = this.store.select(selectMakes);
      this.models$ = this.store.select(selectModels);
      this.versions$ = this.store.select(selectVersions);

      this.fetchingPreview$ = store.select(selectSearchFetchingPreview);
      this.previewTotalCount$ = store.select(selectAllSearchedCarsPreviewTotalCount);
      this.searchCriteria$ = store.select(selectSearchCriteria);
      //this.selectedCountryCodes$ = store.select(selectSelectedCountryCodes);

      this.todayDate = new Date();
      this.tomorrowDate = new Date(this.todayDate);
      this.yesterdayDate = new Date(this.todayDate);

      this.tomorrowDate.setDate(this.todayDate.getDate()+1);
      this.yesterdayDate.setDate(this.todayDate.getDate()-1);

      this.selectedDateRange = new DateRange<Date>(this.todayDate, this.tomorrowDate);

    //this.carCriteria.startDate = new Date(this.todayDate).toISOString();
    //this.carCriteria.endDate = new Date(this.tomorrowDate).toISOString();
  
    }

  ngOnInit(): void {

    this.carCriteria.businessLine = this.selectedBusinessLine!;

    this.store.dispatch(CarRefActions.makesFetchSubmit( {}));

    console.log('dates = '+this.carCriteria.startDate)

    switch(this.selectedBusinessLine!.toString()){
      case CarBusinessLine.BUY.toString() : {
        this.pMin = AppConstants.CAR_PRICE.SALE.MIN;
        this.pMax = AppConstants.CAR_PRICE.SALE.MAX;
        this.step = AppConstants.CAR_PRICE.SALE.STEP;
        break;
      }

      case CarBusinessLine.RENT.toString() : {
        this.pMin = AppConstants.CAR_PRICE.RENTAL.MIN;
        this.pMax = AppConstants.CAR_PRICE.RENTAL.MAX;
        this.step = AppConstants.CAR_PRICE.RENTAL.STEP;
        break;
      }
    }

    this.carCriteria.priceMin = this.pMin;
    this.carCriteria.priceMax = this.pMax;
    //this.carCriteria.businessLines = [this.selectedBusinessLine!.toString()];
    
    this.carMakesBD = CarBasicData.getMakesBD();
    this.countriesBD = GeneralBasicData.getAllCountries();

    this.searchCriteria$.subscribe(criteria => {

      this.carCriteria = JSON.parse(JSON.stringify(criteria));
      //this.selectedCountryCodes = this.carCriteria.countries;
      this.carCriteria.businessLine = this.selectedBusinessLine!;
      this.selectedCountryCodes = this.carCriteria.countries;
      //this.carCriteria.businessLines = [this.selectedBusinessLine!];
      
      this.updateModelsBD();
      this.updateCitiesBD();
      //this.selectedBusinessLine = criteria.businessLines![0];
      this.store.dispatch(SearchActions.searchPreviewCriteriaSubmit({carCriteria: JSON.parse(JSON.stringify(this.carCriteria))}));
   
    });

    this.models$.subscribe(
      (models: CarModel[]) =>  {
        //this.selectedModels = models.filter(item => this.selectedModelsIds.includes(item.id));
        this.selectedModels = models.filter(model => this.selectedModels.findIndex(md => model.id == md.id) >= 0);
        this.carCriteria.models = this.selectedModels.map(item => item.name);
        this.onCriteriaChange();
      }
    ); 

    this.versions$.subscribe(
      (versions: CarVersion[]) =>  {
        //this.selectedModels = models.filter(item => this.selectedModelsIds.includes(item.id));
        this.selectedVersions = versions.filter(version => this.selectedVersions.findIndex(ver => version.id == ver.id) >= 0);
        this.carCriteria.versions = this.selectedVersions.map(item => item.name);
        this.onCriteriaChange();
      }
    ); 

  /* 
    this.selectedCountryCodes$.subscribe(
      (countryCodes) => {

        //this.selectedCountryIds = countryCodes.length !== 0 ? countryCodes : ["All"];
        //this.selectedCountries = GeneralBasicData.getCountriesByCodes(countryCodes)!;
        //this.selectedCountryCodes = countryCodes;
        //this.selectedCountryCodes1 = countryCodes;
        //this.citiesBD = GeneralBasicData.getAllCities(countryCodes);
        //this.carCriteria.countries = countryCodes;
        //this.store.dispatch(SearchActions.fetchRecentCarBriefsSubmit({countryCodes: countryCodes}));
        this.updateCitiesSelector();
      }
    );
/*
    
*/
    //this.store.dispatch(SearchActions.searchPreviewCriteriaSubmit({carCriteria: JSON.parse(JSON.stringify(this.carCriteria))}));
   
  }

  updateModelsBD(): void{

    this.carModelsBD = CarBasicData.getModelsBD(this.carCriteria.makes);
   
  }

  updateCitiesBD(): void{

    //this.citiesBD = GeneralBasicData.getAllCities(this.carCriteria.countries);
    this.citiesBD = GeneralBasicData.getAllCities(this.selectedCountryCodes);
   
  }

  updateModelsSelector(): void{
    this.carCriteria.makes = this.selectedMakes.map(mk => mk.name);
    this.carCriteria.models = []; //this.carCriteria.models.filter(md => this.carCriteria.makes)
    //this.carModelsBD = CarBasicData.getModelsBD(this.carCriteria.makes);
    this.store.dispatch(CarRefActions.modelsFetchSubmit( {makeIds: this.selectedMakes.map(mk => mk.id)}));
    //this.selectedModels = this.selectedModels.filter(md => { return this.selectedMakes.findIndex( mk => mk.name === md.makeName) > 0 }) ;
  }

  updateCitiesSelector(): void{
    this.carCriteria.cities = [];
    this.citiesBD = GeneralBasicData.getAllCities(this.carCriteria.countries);
  }

  onBusinessLineChange() {
    //console.log(this.carCriteria);

    this.carCriteria.businessLine = this.selectedBusinessLine!;

    switch(this.selectedBusinessLine) { 
      case CarBusinessLine.BUY.toString(): { 
        this.pMin = AppConstants.CAR_PRICE.SALE.MIN;
        this.pMax = AppConstants.CAR_PRICE.SALE.MAX;
        this.step = AppConstants.CAR_PRICE.SALE.STEP; 
        break; 
      } 
      case CarBusinessLine.RENT.toString(): { 
        this.pMin = AppConstants.CAR_PRICE.RENTAL.MIN;
        this.pMax = AppConstants.CAR_PRICE.RENTAL.MAX;
        this.step = AppConstants.CAR_PRICE.RENTAL.STEP;
        break; 
      } 

   }

    this.carCriteria.priceMin = this.pMin;
    this.carCriteria.priceMax = this.pMax;

    //this.carCriteria.businessLines = [this.selectedBusinessLine!];
    this.submitSearchPreview();
  }

  onMakesChange(makes: CarMake[]){

    this.carCriteria.makes = makes.map(item => item.name);
    this.carCriteria.models = [];
    this.carCriteria.versions = [];
    this.store.dispatch(CarRefActions.modelsFetchSubmit( { makeIds: makes.map(item => item.id) } ));
    //this.selectedModels.filter(md => this.carCriteria.makes.findIndex(mk => md.makeName == mk) >= 0);
    //console.log(this.selectedModelsIds)
    //this.onCriteriaChange();
  }

  onModelsChange(models: CarModel[]){
    this.carCriteria.models = models.map(item => item.name);
    this.carCriteria.versions = [];
    this.store.dispatch(CarRefActions.versionsFetchSubmit( { modelIds: models.map(item => item.id) } ));
    //this.onCriteriaChange();
  }

  onVersionsChange(versions: CarVersion[]){
    this.carCriteria.versions = versions.map(item => item.name);
    this.onCriteriaChange();
  }

  onCriteriaChange() {
    //console.log(this.carCriteria);
    //this.carCriteria.makes = this.selectedMakes.map(mk => mk.name);
    //this.carCriteria.models = this.selectedModels.map(md => md.name);
    this.submitSearchPreview();
  }

  submitSearchPreview(){

    //this.carCriteria = JSON.parse(JSON.stringify(this.searchForm.value));
    this.carCriteria.businessLine = this.selectedBusinessLine!;
    this.store.dispatch(SearchActions.searchPreviewCriteriaSubmit( { carCriteria: JSON.parse(JSON.stringify(this.carCriteria)) }));
     
  }

  submitSearchForm(): void {
    //if (this.searchForm.valid) {
      
      //this.store.dispatch(SearchActions.changeSelectedCountriesSubmit({ countryCodes: crt.countries }));
    
      ///this.store.dispatch(SearchActions.searchCriteriaSubmit({carCriteria: crt}));

      ///this.updateShowCriteria();

      //this.carCriteria.businessLines = [this.selectedBusinessLine!];

      let crt = JSON.parse(JSON.stringify(this.carCriteria));

      crt.pageNumber = 0;

      if(window.innerWidth <= AppConstants.SCREEN_BREAK_L ){
        this.showCriteriaPanel = false;
      }
      
      switch(this.selectedBusinessLine!.toString()){
        case CarBusinessLine.BUY.toString():{
          this.router.navigate(
            ['/buy/search'],
            { queryParams: crt }
          );
          break;
        }
        case CarBusinessLine.RENT.toString():{
          this.router.navigate(
            ['/rent/search'],
            { queryParams: crt }
          );
          break;
        }
      }

    //} 
    
  }

  resetSearch(): void {

    //this.store.dispatch(SearchActions.resetCarCriteriaForm());
    this.carCriteria = new CarCriteria();
    let crt = JSON.parse(JSON.stringify(this.carCriteria));
    this.store.dispatch(SearchActions.searchPreviewCriteriaSubmit( { carCriteria: crt }));
    

  }

  formatSliderLabel(value: any): string {

    return AppFunctions.numberWithSpaces(""+value);
  }

  saveAlert(): void {

    let crt: CarCriteria = JSON.parse(JSON.stringify(this.carCriteria));
    crt.businessLine = this.selectedBusinessLine!;
    console.log(crt);

    this.store.dispatch(DealerActions.addNewAlertSubmit({criteria: crt }));
    alert("search will be added to your alerts");

  }

  toggleShowCriteria(): void{
    this.showCriteriaPanel = !this.showCriteriaPanel;
  }

  onResize(event: any) {
    //this.updateShowCriteria();
  }

  updateShowCriteria(){
    if(window.innerWidth > AppConstants.SCREEN_BREAK_L){
      this.showCriteriaPanel = true;
    }
    else{
      this.showCriteriaPanel = false;
    }  
  }

  updateCountries(event: any){

    this.carCriteria.countries = event.value;
    this.selectedCountryCodes = event.value;
    this.updateCitiesSelector();
    //this.store.dispatch(SearchActions.changeSelectedCountriesSubmit({ countryCodes: event.value}));
    this.onCriteriaChange();
  }


  onSelectedDatesChange(event: any){

    //console.log('hellooo '+event.value);
    if(this.carCriteria.endDate != null &&  this.carCriteria.endDate !== ""){
      //console.log('start '+ this.carCriteria.startDate);
      //console.log('end '+ this.carCriteria.endDate);
      this.onCriteriaChange();
    }
    
  }

  filterPastDates = (date: Date | null): boolean => {

    if ( ! (date! > this.yesterdayDate) ) {
      return false;
    } 

    return true;
  }

}
